import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

const isSuccessResult = (response) =>
  response?.result === "OK" || response?.message === "OK";

const isNotFoundResult = (response) => {
  const code = response?.result || response?.message;
  return code === "NOT_FOUND" || code === "NOTFOUND";
};

/**
 * @param {{ params?: object, query?: { customerId?: string, productId?: string, page?: number, limit?: number } }} option
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.ProductCustomPrice.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{ customerId: string, productId: string, price: number, costPrice: number }} form
 */
export const Upsert = async (form) => {
  const response = await $api.post(Endpoints.ProductCustomPrice.Upsert(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{ params: { customerId: string, productId: string }, query?: object }} option
 */
export const Get = async (option) => {
  const response = await $api.get(Endpoints.ProductCustomPrice.Get(option));
  if (isNotFoundResult(response) && !isSuccessResult(response)) {
    return { message: "NOT_FOUND", isSuccess: false, data: null };
  }
  if (isSuccessResult(response)) {
    return { ...response, message: "OK", isSuccess: true };
  }
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { customerId: string, productId: string }, query?: object }} option
 */
export const Delete = async (option) => {
  const response = await $api.delete(
    Endpoints.ProductCustomPrice.Delete(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Upsert,
  Get,
  Delete,
};
